import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import ScopeSelector from "../components/ScopeSelector";
import { removedScopes, scopeLabel } from "../utils/scopeCatalog";

// Escolha dos produtos de um cliente, na criação e na edição. Montado só
// enquanto aberto, então a seleção nasce de `initialScopes` a cada abertura.
//
// Na edição, a retirada de produto é avisada antes de salvar: o cliente perde o
// acesso na requisição seguinte, sem período de graça.
//
// Enquanto salva, o modal trava inteiro (fechar e marcar): a seleção na tela
// tem que ser a que foi enviada, e fechar no meio esconderia o erro.
export default function ClientScopesModal({
  title,
  description,
  initialScopes,
  confirmLabel,
  saving,
  errorMessage,
  onConfirm,
  onHide,
}) {
  const [selectedScopes, setSelectedScopes] = useState(initialScopes);
  const scopesBeingRemoved = removedScopes(initialScopes, selectedScopes);

  return (
    <Modal
      show
      onHide={saving ? undefined : onHide}
      backdrop={saving ? "static" : true}
      keyboard={!saving}
      size="lg"
      centered
    >
      <Modal.Header closeButton={!saving}>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {description}

        {errorMessage && (
          <div className="alert alert-warning" role="alert">
            {errorMessage}
          </div>
        )}

        <fieldset disabled={saving}>
          <ScopeSelector
            selectedScopes={selectedScopes}
            onChange={setSelectedScopes}
          />
        </fieldset>

        {scopesBeingRemoved.length > 0 && (
          <div className="alert alert-danger mt-4 mb-0" role="alert">
            Ao salvar, o cliente <strong>perde o acesso imediatamente</strong> a:{" "}
            {scopesBeingRemoved.map(scopeLabel).join(", ")}.
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="light" onClick={onHide} disabled={saving}>
          Cancelar
        </Button>
        <Button
          variant={scopesBeingRemoved.length > 0 ? "danger" : "primary"}
          onClick={() => onConfirm(selectedScopes)}
          disabled={saving}
        >
          {confirmLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
